<template>
  <b-card no-body>
    <b-card-header class="pb-1">
      <h5>{{ $t("Filters") }}</h5>
    </b-card-header>
    <b-card-body class="py-5">
      <b-row>
        <b-col cols="12" md="3" class="mb-md-0 mb-2">
          <label>Facility</label>
          <treeselect
            id="type_consult"
            v-model="facilityId"
            :options="facilityOptions"
            :normalizer="normalizer"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-md-0 mb-2 mt-2 ml-auto" align="end">
          <b-button variant="warning" @click="resetFilter" class="mr-1">
            {{ $t("Clear") }}
          </b-button>
          <b-button
            :disabled="!facilityId"
            variant="primary"
            @click="
              $router.push({ name: 'cash-history', params: { id: facilityId } })
            "
          >
            <span>{{ $t("Search") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
} from "bootstrap-vue";

import axiosF from "@/core/services/api/admin/facilities";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
  },
  data() {
    return {
      facilityId: null,
      facilityOptions: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  mounted() {
    this.getFacilityOptions();
  },
  methods: {
    resetFilter() {
      this.facilityId = null;
    },
    getFacilityOptions() {
      axiosF.facilityList(20).then(({ data }) => {
        this.facilityOptions = data;
      });
    },
  },
};
</script>

<style></style>
